import Layout from "../Layout";
import Dashboard from "../pages/Dashboard/Dashboard";
import Substore from "../pages/Users/Substore";
import Offers from "../pages/Offers/Offers";
import Profile from "../pages/Account/Profile";
import Auth from "../components/Auth";
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import ForgotPassword from "../pages/auth/ForgotPassword";
import NotFound from "../components/NotFound";
import CreateOrder from "../pages/Order/CreateOrder";
import { AuthProtected, ProtectedRoute } from "./protectedRoute";
import Earning from "../pages/Earning/Earning";
import CurrentMonth from "../pages/Earning/CurrentMonth";
import CurrentWeek from "../pages/Earning/CurrentWeek";
import Storesetting from "../pages/Settings/Storesetting";
import Deliverysettings from "../pages/Settings/Deliverysettings";
import Storetimesettings from "../pages/Settings/Storetimesettings";
import StoreReviews from "../pages/History/StoreReviews.jsx";
import ProductReview from "../pages/History/ProductReview.jsx";
import Category from "../pages/Menu/Category";
import ImportExportData from "../pages/Menu/ImportExportData";
import CancellationPolicy from "../pages/Settings/CancellationPolicy";
import BasicSettings from "../pages/Settings/BasicSettings";
import AllOrder from "../pages/Order/AllOrder";
import PendingOrder from "../pages/Order/PendingOrder";
import AcceptedOrder from "../pages/Order/AcceptedOrder";
import AssignedOrder from "../pages/Order/AssignedOrder";
import DeliveredOrder from "../pages/Order/DeliveredOrder";
import ReturnOrder from "../pages/Order/ReturnOrder";
import CancelOrder from "../pages/Order/CancelOrder";
import ReplaceOrder from "../pages/Order/ReplaceOrder";
import Sale from "../pages/Offers/Sale";
import { ErrorBoundary } from "react-error-boundary";
import ErrorPage from "../custom/ErrorPage";
import VerifyOtp from "../pages/auth/VerifyOtp";
import ChangePassword from "../pages/auth/ChangePassword";
import PromoManagement from "../pages/PromoManagement/PromoManagement";
import ProductDetails from "../pages/ProductDetails/ProductDetails.jsx";
import ApprovalCheck from "../pages/auth/ApprovalCheck.jsx";
import AUCategory from "../pages/ApproveUnapprove/Category/AUCategory.jsx";
import AUSubcategory from "../pages/ApproveUnapprove/Subcategory/AUSubcategory.jsx";
import AUItem from "../pages/ApproveUnapprove/Item/AUItem.jsx";
import AUPromocode from "../pages/ApproveUnapprove/AUPromocode/AUPromocode.jsx";
import AUAdvertisement from "../pages/ApproveUnapprove/Advertisement/AUAdvertisement.jsx";
import AURejected from "../pages/ApproveUnapprove/Rejected/AURejected.jsx";
import AUPromosale from "../pages/ApproveUnapprove/AUPromocode/AUPromosale.jsx";
import AUSubCategoryRejected from "../pages/ApproveUnapprove/Rejected/AUSubCategoryRejected.jsx";
import AUItemRejected from "../pages/ApproveUnapprove/Rejected/AUItemRejected.jsx";
import AUPromocodeRejected from "../pages/ApproveUnapprove/Rejected/AUPromoCodeRejected.jsx";
import AUSaleRejected from "../pages/ApproveUnapprove/Rejected/AUSaleRejected.jsx";
import AUAdvertiseRejected from "../pages/ApproveUnapprove/Rejected/AUAdvertiseRejected.jsx";
import GRV from "../pages/InventoryManagement/GRV/GRV.jsx";
import GIV from "../pages/InventoryManagement/GIV/GIV.jsx";
import StockLedgerReport from "../pages/InventoryManagement/StockLedgerReport/StockLedgerReport.jsx";
import StockOnHandReport from "../pages/InventoryManagement/StockOnHandReport/StockOnHandReport.jsx";
import Resources from "../pages/Menu/Resources.jsx";

import Dispatch from "../pages/Order/Dispatch/Dispatch.jsx";
import ItemListCashcrop from "../pages/Menu/ItemListCashcrop.jsx";
import BulkChat from "../pages/BulkChat/BulkChat.jsx";
import Orders from "../pages/Earning/Orders/Orders.jsx";
import Notifications from "../pages/Notifications.jsx";
import Complaints from "../pages/Complaints/Complaints.jsx";

const userData = localStorage.getItem("persist:user");

if (userData) {
  const user = userData && JSON.parse(userData);
  // console.log('----->',JSON.parse(user.store));
  const currentUser = JSON.parse(user.store);
  console.log("----->", currentUser?.currentUser?.delivery_business);
}


export const ProtectedRouters=[{
  path: "store",
    element: (
      <ProtectedRoute>
        <ErrorBoundary fallback={<ErrorPage />}>
          <Layout />
        </ErrorBoundary>
      </ProtectedRoute>
    ),
  children:[
  {
    path: "dashboard",
    element: <Dashboard />,
  },
  {
    path: "order/create-order",
    element: <CreateOrder />,
  },
  {
    path: "order/all-orders",
    element: <AllOrder />,
  },
  {
    path: "order/pending-orders",
    element: <PendingOrder />,
  },
  {
    path: "order/accepted-orders",
    element: <AcceptedOrder />,
  },
  {
    path: "order/assigned-orders",
    element: <AssignedOrder />,
  },
  {
    path: "order/delivered-orders",
    element: <DeliveredOrder />,
  },
  {
    path: "order/return-order",
    element: <ReturnOrder />,
  },
  {
    path: "order/cancel-order",
    element: <CancelOrder />,
  },
  {
    path: "order/replacement",
    element: <ReplaceOrder />,
  },
  {
    path: "order/dispatch",
    element: <Dispatch/>,
  },
  {
    path: "order/store-reviews",
    element: <StoreReviews />,
  },
  {
    path: "order/product-reviews",
    element: <ProductReview />,
  },
  {
    path: "reviews",
    element: <ProductReview />,
  },
  
  {
    path: "product-details/:productId",
    element: <ProductDetails />,
  },
  

  // {
  //   path: "order/table-booking",
  //   element: <TableBooking />,
  // },

      // {
      //   path: "history/current-week",
      //   element: <HistoryCurrentWeek />,
      // },
      // {
      //   path: "history/current-month",
      //   element: <HistoryCurrentMonth />,
      // },
      // {
      //   path: "history/history-list",
      //   element: <History />,
      // },
       {
        path: "complaints",
        element: <Complaints />,
      },

      {
        path: "earning/earnings",
        element: <Earning />,
      },
      {
        path: "earning/order",
        element: <Orders />,
      },
      {
        path: "bulkchat/chats",
        element: <BulkChat />,
      },
      {
        path: "earning/current-week",
        element: <CurrentWeek />,
      },
      {
        path: "earning/current-month",
        element: <CurrentMonth />,
      },
      {
        path: "inventory/grv",
        element: <GRV />,
      },
      {
        path: "inventory/giv",
        element: <GIV />,
      },
      {
        path: "inventory/stock-on-hand-report",
        element: < StockOnHandReport/>,
      },
      {
        path: "inventory/stock-ledger-report",
        element: <StockLedgerReport />,
      },

      {
        path: "menu/item-list",
        element: <ItemListCashcrop />,
      },
      {
        path: "menu/edu-resources",
        element: <Resources />,
      },
      {
        path: "menu/category",
        element: <Category />,
      },       
      {
        path: "menu/import-data",
        element: <ImportExportData />,
      },
      {
        path: "users/sub-stores",
        element: <Substore />,
      },
      {
        path: "offers/promocode",
        element: <Offers />,
      },
      {
        path: "offers/sale",
        element: <Sale />,
      },
      // {
      //   path:"menu/funding-opportunity",
      //   element:<FinancingFunding/>
      // },
      {
        path: "Promotion/advertisement-management",
        element: <PromoManagement />,
      },

  // approval/reject routes start
  {
    path: "approvals/category",
    element: <AUCategory />,
  },
  {
    path: "approvals/sub-category",
    element: <AUSubcategory />,
  },
  {
    path: "approvals/item",
    element: <AUItem />,
  },
  {
    path: "approvals/promo-code",
    element: <AUPromocode />,
  },
  {
    path: "approvals/sale",
    element: <AUPromosale />,
  },
  {
    path: "approvals/advertise",
    element: <AUAdvertisement />,
  },
  {
    path: "approvals/category-reject",
    element: <AURejected />,
  },
  {
    path: "approvals/subcategory-reject",
    element: <AUSubCategoryRejected />,
  },
  {
    path: "approvals/item-reject",
    element: <AUItemRejected />,
  },
  {
    path: "approvals/promo-code-reject",
    element: <AUPromocodeRejected />,
  },
  {
    path: "approvals/sale-reject",
    element: <AUSaleRejected />,
  },
  {
    path: "approvals/advertise-reject",
    element: <AUAdvertiseRejected />,
  },
  // approval/reject routes end

  {
    path: "settings/store-settings",
    element: <Storesetting />,
  },
  {
    path: "settings/delivery-settings",
    element: <Deliverysettings />,
  },
  {
    path: "settings/store-time-settings",
    element: <Storetimesettings />,
  },
  {
    path: "settings/table-booking-basic-settings",
    element: <BasicSettings />,
  },
  {
    path: "settings/table-booking-cancellation-policy",
    element: <CancellationPolicy />,
  },
  {
    path: "profile",
    element: <Profile />,
  },
  {
    path: "notifications",
    element: <Notifications />,
  },
]
},
// {
//   meta: {
//     name: "Product Reviews",
//     link: "product/get-product-by-id/:productId",
//   },
//   path: "product/get-product-by-id/:productId",
//   element: <ProductDetails meta={[]} />,
// },
{
  path: "store/approval-check",
  element: <ApprovalCheck />,
},
]

export const publicRouters = [
  {
    path: "/",
    element: (
      <AuthProtected>
        <ErrorBoundary fallback={<ErrorPage />}>
          <Auth />
        </ErrorBoundary>
      </AuthProtected>
    ),
    children: [
      {
        path: "/",
        element: <Login />,
      },
      {
        path: "register",
        element: <Register />,
      },
      {
        path: "forgot-password",
        element: <ForgotPassword />,
      },
      {
        path: "verify-otp",
        element: <VerifyOtp />,
      },
      {
        path: "change-password",
        element: <ChangePassword />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];




